<script>
export default {
    name: "InfoCardsEmptyItem"
}
</script>

<template>
    <div class="hidden lg:block rounded-2xl  border bg-grayBg border-grayBg p-5 w-full h-full shadow-lg"></div>
</template>

<style scoped lang="scss">

</style>
